import { render, staticRenderFns } from "./userMessage_desktop.vue?vue&type=template&id=5a51f077&scoped=true&"
import script from "./userMessage_desktop.vue?vue&type=script&lang=js&"
export * from "./userMessage_desktop.vue?vue&type=script&lang=js&"
import style0 from "./userMessage_desktop.vue?vue&type=style&index=0&id=5a51f077&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a51f077",
  null
  
)

export default component.exports